<template>
	<v-container fluid>
    <v-layout row wrap>
      <v-flex md12>
        <consumption-table></consumption-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import consumptionTable from '@/components/reports/consumption/ConsumptionTable';

export default {
  components: {
    consumptionTable,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/reports/consumption/Index.vue